import { State } from "Interfaces/storeSchema"
import Image from "next/image"
import React, { FunctionComponent } from "react"
import { useSelector } from "react-redux"
import { toast, ToastContainer } from "react-toastify"

const CallUsBanner: FunctionComponent = () => {
  const { inboundSalesNumber } = useSelector((state: State) => state.IeltsElite)
  const copyToClipboard = async () => {
    const number = inboundSalesNumber ? `${inboundSalesNumber}` : "08065196400"
    try {
      await navigator.clipboard.writeText(number)
      toast.success(
        <div className="text-center text-sm">Number copied to clipboard!</div>,
        {
          position: "bottom-center",
          style: {
            background: "black",
            width: "250px",
            margin: "auto",
            borderRadius: "8px",
          },
          closeButton: <p className="hidden"></p>,
        },
      )
    } catch (err) {
      console.error("Failed to copy text: ", err)
      toast.error("Failed to copy the number. Please try again.")
    }
  }
  return (
    <div className="relative bg-white rounded-xl shadow py-8 px-[36px]">
      <div className="justify-between items-center flex w-full flex-col md:flex-row gap-y-4">
        <div className="justify-center items-center gap-[22px] flex">
          <div className="flex-col justify-start items-start gap-1.5 inline-flex">
            <div className="self-stretch text-black text-[22px] font-bold font-['Noto Sans'] leading-[30.80px] md:text-left text-center">
              Don't want to wait?
            </div>
            <div className="justify-start items-start gap-1.5 inline-flex">
              <div className="text-center text-[#77768e] text-sm font-normal font-['Figtree'] leading-[21px]">
                Start a conversation with our expert right away.
              </div>
            </div>
          </div>
        </div>
        <div className="justify-start items-center gap-6 flex">
          <div className="flex flex-col">
            <span className="text-[#8b8aa2] text-base font-medium font-['Poppins'] leading-normal">
              call us on
            </span>
            <span className="text-black text-base font-bold font-['Public Sans'] leading-normal">
              {inboundSalesNumber ? `${inboundSalesNumber}` : "08065196400"}
            </span>
          </div>
          <div className="h-[47px] border border-[#e2e2e8]"></div>
          <div
            onClick={async () => await copyToClipboard()}
            className="p-4 bg-[#f8f7ff] rounded-lg justify-center items-center gap-2 flex cursor-pointer"
          >
            <Image
              src={`${process.env.CDN_URL}/assets/icons/copy.svg`}
              height={24}
              width={24}
            />
            <div className="text-[#7672f7] text-base font-bold font-['Public Sans'] leading-normal">
              Copy Number
            </div>
          </div>
        </div>
      </div>
      <ToastContainer
        position="bottom-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnHover
      />
    </div>
  )
}

export default CallUsBanner
